import { createAction } from '@reduxjs/toolkit';

// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const resetStore = createAction('LOGOUT');
